import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Reseta o scroll da janela ao topo em cada navegação SPA (PUSH/REPLACE).
 * Sem isso, o React Router preserva o scrollY da página anterior — ex.:
 * rolar a lista de /avaliacoes até o fim e abrir uma avaliação exibia o
 * detalhe já no rodapé.
 *
 * Exceções intencionais:
 * - POP (voltar/avançar do navegador): mantém a posição, comportamento
 *   esperado de histórico.
 * - Navegação com hash (#pricing etc.): as âncoras das landings têm scroll
 *   próprio (src/components/landing/lp/scroll.ts).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    if (navigationType === 'POP') return
    if (hash) return
    window.scrollTo(0, 0)
  }, [pathname, hash, navigationType])

  return null
}
